
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/academy",
      function () {
        return require("private-next-pages/docs/academy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/academy"])
      });
    }
  